import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import { LinearProgress, Paper } from 'material-ui';
import ContractList from '../../../contract-list/contract-list-container';
// import SimpleContractList from '../../../generic-components/simpleContractList';

import {
  fileContractForRequest as fileContractForRequestAction,
  removeContractFromRequest as removeContractFromRequestAction,
} from '../../../__storeFiles__/actions';

const propTypes = {
  contractId: PropTypes.string,
  respondedContractList: PropTypes.array,
  fileContractForRequest: PropTypes.func,
  respondedContracts: PropTypes.array,
  removeContractFromRequest: PropTypes.func,
  hideBtns: PropTypes.bool,
};

class RespondedContractList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removing: [],
      filingContractId: '',
      allCheckedIds: [],
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  onCheckContract = contractId => (_, checked) => this.setState({
    allCheckedIds: checked ? [...this.state.allCheckedIds, contractId]
      : this.state.allCheckedIds.filter(id => id !== contractId),
  });
  onCheckAll = (_, checked) => {
    this.setState({
      allCheckedIds: checked ? this.props.respondedContracts
        : [],
    });
  }
  fileContractForRequest = contractId => () => {
    this.setState({
      filingContractId: contractId,
    });
    this.props.fileContractForRequest({
      contractId,
      requestId: this.props.contractId,
    });
  };
  removeContractFromRequest = contractIds => () => {
    this.setState({
      removing: contractIds,
      allCheckedIds: [],
    });
    this.props.removeContractFromRequest({
      contractIds,
      requestId: this.props.contractId,
    });
  };
  render() {
    const {
      // contractId,
      respondedContractList,
      respondedContracts,
      // hideBtns,
    } = this.props;
    const hasTCRates = Boolean(respondedContracts && respondedContracts.length);
    const loadedContractFiles = Boolean(respondedContractList && respondedContractList.length);
    if (!hasTCRates) return <div/>;
    return (
      <div style={{ marginBottom: '24px' }}>
        {
          hasTCRates && !loadedContractFiles && (
            <Paper style={{ padding: '16px' }}>
              <h4>Loading TourConnect format rates...</h4>
              <LinearProgress/>
            </Paper>
          )
        }
        {
          loadedContractFiles && (
            <div>
              {/* <Paper className="flex-tc-sb" style={{ padding: '8px 32px', marginTop: '12px' }}>
                <Checkbox
                  label="Select All"
                  style={{ width: '50%' }}
                  checked={this.state.allCheckedIds.length === respondedContracts.length}
                  onCheck={this.onCheckAll}
                />
                {
                  !hideBtns && (
                    <RaisedButton
                      label="Remove All"
                      primary
                      disabled={Boolean(!this.state.allCheckedIds.length)}
                      onClick={this.removeContractFromRequest(this.state.allCheckedIds)}
                    />
                  )
                }
              </Paper> */}
              <ContractList
                inWhere="workspace"
              />
              {/* <SimpleContractList
                contracts={respondedContractList}
                viewingBy="Contractor"
                style={{ width: '100%' }}
                inRequest={{
                  fileContractForRequest: this.fileContractForRequest,
                  removeContractFromRequest: this.removeContractFromRequest,
                  requestId: contractId,
                  filingContractId: this.state.filingContractId,
                  removingContractIds: this.state.removing,
                  onCheckContract: this.onCheckContract,
                  allCheckedIds: this.state.allCheckedIds,
                  hideBtns,
                }}
              /> */}
            </div>
          )
        }
      </div>
    );
  }
}

RespondedContractList.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  fileContractForRequest: (...args) => dispatch(fileContractForRequestAction(...args)),
  removeContractFromRequest: (...args) => dispatch(removeContractFromRequestAction(...args)),
});
export default connect(({ contracting }) => {
  const leftNav = contracting.contractActivitiesProducts.get('leftNav').toJS();
  return {
    contractId: leftNav.contractId,
    respondedContractList: leftNav.respondedContractList,
    respondedContracts: leftNav.respondedContracts,
  };
}, mapDispatchToProps)(RespondedContractList);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/contract-request-buyer-view/responded-contract-list.jsx